// extracted by mini-css-extract-plugin
module.exports = {"login-button":"MicrosoftButton_login-button__2yEl2"};